import React from 'react';
import Select from '../../../components/ui/Select';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const FilterControls = ({ 
  filters, 
  onFilterChange, 
  onResetFilters,
  showComparison,
  selectedCount 
}) => {
  const interestOptions = [
    { value: 'all', label: 'Tous les domaines' },
    { value: 'sciences', label: 'Sciences et Technologies' },
    { value: 'humanities', label: 'Sciences Humaines' },
    { value: 'business', label: 'Commerce et Gestion' },
    { value: 'arts', label: 'Arts et Créativité' },
    { value: 'health', label: 'Santé et Médecine' }
  ];

  const difficultyOptions = [
    { value: 'all', label: 'Tous les niveaux' },
    { value: 'easy', label: 'Accessible' },
    { value: 'medium', label: 'Intermédiaire' },
    { value: 'hard', label: 'Exigeant' }
  ];

  const demandOptions = [
    { value: 'all', label: 'Toutes les demandes' },
    { value: 'high', label: 'Forte demande' },
    { value: 'medium', label: 'Demande moyenne' },
    { value: 'low', label: 'Demande faible' }
  ];

  const sortOptions = [
    { value: 'compatibility', label: 'Compatibilité (décroissant)' },
    { value: 'demand', label: 'Demande du marché' },
    { value: 'salary', label: 'Salaire potentiel' },
    { value: 'difficulty', label: 'Niveau de difficulté' }
  ];

  return (
    <div className="bg-white rounded-xl border border-gray-200 p-4 md:p-6 mb-6">
      <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4 mb-4">
        <h2 className="text-lg md:text-xl font-semibold text-gray-800 flex items-center gap-2">
          <Icon name="SlidersHorizontal" size={24} color="var(--color-primary)" />
          Filtres et Tri
        </h2>
        {selectedCount > 0 && (
          <div className="flex items-center gap-2 bg-blue-50 text-blue-700 px-4 py-2 rounded-lg">
            <Icon name="CheckSquare" size={20} />
            <span className="text-sm font-medium">{selectedCount} filière(s) sélectionnée(s)</span>
          </div>
        )}
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-4">
        <Select
          label="Domaine d'intérêt"
          options={interestOptions}
          value={filters?.interest}
          onChange={(value) => onFilterChange('interest', value)}
          placeholder="Sélectionner un domaine"
        />

        <Select
          label="Niveau de difficulté"
          options={difficultyOptions}
          value={filters?.difficulty}
          onChange={(value) => onFilterChange('difficulty', value)}
          placeholder="Sélectionner un niveau"
        />

        <Select
          label="Demande du marché"
          options={demandOptions}
          value={filters?.demand}
          onChange={(value) => onFilterChange('demand', value)}
          placeholder="Sélectionner la demande"
        />

        <Select
          label="Trier par"
          options={sortOptions}
          value={filters?.sort}
          onChange={(value) => onFilterChange('sort', value)}
          placeholder="Sélectionner le tri"
        />
      </div>
      <div className="flex flex-col sm:flex-row gap-3">
        <Button
          variant="outline"
          iconName="RotateCcw"
          iconPosition="left"
          onClick={onResetFilters}
          className="flex-1 sm:flex-initial"
        >
          Réinitialiser les filtres
        </Button>
        {selectedCount >= 2 && (
          <Button
            variant="default"
            iconName="GitCompare"
            iconPosition="left"
            onClick={showComparison}
            className="flex-1 sm:flex-initial"
          >
            Comparer ({selectedCount})
          </Button>
        )}
      </div>
    </div>
  );
};

export default FilterControls;